"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useState } from "react";
import GroupsSidebarApp from "@/components/groups/sidebar/GroupsSidebarApp";
import GroupsSidebarAppToggle from "@/components/groups/sidebar/GroupsSidebarAppToggle";
export default function SidebarLayoutApp(t0) {
  const $ = _c(10);
  const {
    children
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpen(false);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] !== open) {
    t2 = <GroupsSidebarApp open={open} onClose={t1} />;
    t3 = <GroupsSidebarAppToggle open={open} setOpen={setOpen} />;
    $[1] = open;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children) {
    t4 = <div className="tailwind-scope tw-bg-iron-950 tw-mt-6 lg:tw-mt-8 tw-pb-6 lg:tw-pb-8 tw-px-4 tw-mx-auto">{children}</div>;
    $[4] = children;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <main className="tailwind-scope tw-bg-iron-950 tw-overflow-x-hidden">{t2}{t3}{t4}</main>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}